import type { HealthResponse, ReadinessResponse } from '@solar/contracts';

import { apiClient, type ApiClient } from '../lib/api-client';

/**
 * Health probes.
 *
 * These endpoints return an unwrapped body by design, which the API client
 * passes through untouched.
 */
export const healthService = {
  liveness(client: ApiClient = apiClient): Promise<HealthResponse> {
    return client.get<HealthResponse>('/health/live');
  },

  readiness(client: ApiClient = apiClient): Promise<ReadinessResponse> {
    return client.get<ReadinessResponse>('/health/ready');
  },
};
